import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import styled, { css } from "styled-components";
import { DefaultTheme } from "../Theme";
import { highVisSlateComponent, HIGH_VIS_FILTER } from "../utils/highVisSlateComponent";
export var CentralIconWrapper = styled(Column).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-d958165e-0"
})([
    "position:absolute;top:50%;left:50%;width:calc(100% - ",
    ");transform:translate(-50%,-50%);color:",
    ";",
    ""
], getSpacing("2x"), function(props) {
    return props.$color;
}, function(param) {
    var defaultHidden = param.$defaultHidden;
    return defaultHidden ? css([
        "display:none;"
    ]) : null;
});
export var DropzoneContainer = styled(Column).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-d958165e-1"
})([
    "position:relative;width:",
    ";height:",
    "px;background-color:",
    ";outline:1px dashed ",
    ";outline-offset:-8px;",
    " ",
    ";img{height:100%;width:100%;",
    " object-fit:cover;object-position:center;filter:brightness(100%);background:",
    ";}",
    ""
], function(param) {
    var width = param.$width;
    return width ? css([
        "",
        "px"
    ], width) : css([
        "100%"
    ]);
}, function(param) {
    var height = param.$height;
    return height;
}, function(param) {
    var uploadError = param.$uploadError;
    return uploadError ? Core.surface.critical : DefaultTheme.surface.subdued;
}, Core.border.subdued, function(param) {
    var circleImage = param.$circleImage;
    return circleImage ? css([
        "border-radius:50%;outline:none;div{border-radius:50%;}"
    ]) : null;
}, function(param) {
    var tmp = param.$externallyManagedClicks, externallyManagedClicks = tmp === void 0 ? false : tmp;
    return externallyManagedClicks ? null : css([
        "&:hover{img{filter:brightness(50%);}",
        "{display:flex;}}cursor:pointer;"
    ], CentralIconWrapper);
}, function(param) {
    var circleImage = param.$circleImage;
    return circleImage ? css([
        "border-radius:50%;"
    ]) : null;
}, Core.surface.inverse, highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
export var MaxSizeDiv = styled.div.withConfig({
    componentId: "sc-d958165e-2"
})([
    "max-height:100%;max-width:100%;height:100%;width:100%;"
]);
